module.exports = __webpack_public_path__ + "assets/fonts/icomoon.woff?e007ec42176b43f232701324972a45ef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.woff?i1bfht
// module id = 642
// module chunks = 0